import SurescriptsInformactionContainer from './components/surescripts-information-container';

export default SurescriptsInformactionContainer;
